import { Column, Row } from '../DataTable.types';

const getValues = (propertyIds: string | string[], row: { [p: string]: any }) => {
  if (Array.isArray(propertyIds)) {
    return propertyIds.reduce(
      (acc, key) => (row.hasOwnProperty(key) ? { ...acc, [key]: row[key] } : acc),
      {},
    );
  } else {
    return row.hasOwnProperty(propertyIds) ? row[propertyIds] : '';
  }
};
/**
 * Description:
 * This function parses the JSON Array of data for the table,
 * by matching it against the configuration provided.
 * This means that you don't need to filter it yourself, you can
 * simply update the layout in your container file and the hook will reparse the data
 * for you.
 */
export const mapDataToColumns = (data: { [key: string]: any }[], columns: Column[]): Row[] => {
  if (!Array.isArray(data)) throw Error('Data needs to be in array format');

  return data.map((rowData) => ({
    rowData,
    cells: columns.map((column) => ({
      column,
      value: getValues(column.propertyIds, rowData),
    })),
  }));
};
